import * as React from 'react';
import {
	DataTableCell,
	Popover
} from '@salesforce/design-system-react';
import { Request } from 'lib/types';

const PrivacyCell: React.SFC<{item?: Request}> = ({ children, ...props }) => {
	const item = props.item ? props.item : {} as Request;
	return (
		<DataTableCell {...props}>
			{item.type === 'Privacy Delete' ?
				<Popover
					align="right"
					heading="Privacy Delete"
					body={
						<div>
							<h3>Request Data Source</h3>
							<a href="javascript:void(0);">NTO North America</a>
							<h3 className="slds-m-top_small">Note From Requestor</h3>
							<p className="slds-text-color_weak">
								Farrah requested her information<br />
								be deleted except for orders.
							</p>
						</div>
					}
					style={{
						width: '15rem'
					}}
				>
					<a href="javascript:void(0);">{children}</a>
				</Popover> :
				<a href="javascript:void(0);">{children}</a>
			}
		</DataTableCell>
	);
};
PrivacyCell.displayName = DataTableCell.displayName;

export default PrivacyCell;


// WEBPACK FOOTER //
// ./src/DataStewardship/privacy-cell.tsx